import {Route, BrowserRouter as Router, Switch} from 'react-router-dom'
import {lazy, Suspense} from "react";
import BounceLoader from 'react-spinners/BounceLoader'
import Home from "../components/Home/Home";
import {css} from "@emotion/react";

const CreateInvoice = lazy( () => import('../components/CreateInvoice/CreateInvoice'));
const DownloadInvoice = lazy( () => import('../components/DownloadInvoice/DownloadInvoice'));
const SearchInvoice = lazy( () => import('../components/SearchInvoice/SearchInvoice'));
const SearchSale = lazy( () => import('../components/SearchSale/SearchSale'));

export const AppRouter = () => {
    const override = css`
      display: block;
      margin: 0 auto;
    `;
    return (
        <Router>
            <Suspense fallback={<BounceLoader color={'#0C10F5'} css={override} size={120}/>} >
                <Switch>
                    <Route exact path="/" component={Home} />
                    <Route path="/invoice" component={CreateInvoice} />
                    <Route path="/download" component={DownloadInvoice} />
                    <Route path="/sinvoice" component={SearchInvoice} />
                    <Route path="/sale" component={SearchSale} />
                </Switch>
            </Suspense>
        </Router>
    )
}

export default AppRouter;
